import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import logo from '../Assets/G Sports/PNG/Asset 4@4x.png';
import { COLORS } from '../Constants/styles';
import AccentButton from '../Feature/Common/AccentButton';

const ComingSoon = () => {
    return (
        <Box
            sx={{
                minHeight: '100vh',
                backgroundColor: COLORS.accentDarkGreen,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                px: { xs: 3, md: 6 },
                textAlign: 'center',
                overflow: 'hidden',
                position: 'relative',
            }}
        >
            {/* Background decorative circles */}
            <Box sx={{ position: 'absolute', top: -120, right: -120, width: 400, height: 400, borderRadius: '50%', border: `1px solid rgba(194,252,133,0.15)`, pointerEvents: 'none' }} />
            <Box sx={{ position: 'absolute', top: -60, right: -60, width: 250, height: 250, borderRadius: '50%', border: `1px solid rgba(194,252,133,0.1)`, pointerEvents: 'none' }} />
            <Box sx={{ position: 'absolute', bottom: -100, left: -100, width: 350, height: 350, borderRadius: '50%', border: `1px solid rgba(194,252,133,0.12)`, pointerEvents: 'none' }} />

            <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
            >
                <Box sx={{ position: 'relative', width: { xs: 130, md: 155 }, height: { xs: 130, md: 155 }, mx: 'auto', mb: 5, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                    {/* Outer slow spin ring */}
                    <motion.div
                        animate={{ rotate: 360 }}
                        transition={{ duration: 3, repeat: Infinity, ease: 'linear' }}
                        style={{ position: 'absolute', inset: 0, borderRadius: '50%', border: `3px solid transparent`, borderTopColor: COLORS.accentLime, borderRightColor: COLORS.accentLime }}
                    />

                    {/* Inner fast counter-spin ring */}
                    <motion.div
                        animate={{ rotate: -360 }}
                        transition={{ duration: 1.5, repeat: Infinity, ease: 'linear' }}
                        style={{ position: 'absolute', inset: 8, borderRadius: '50%', border: `2px solid transparent`, borderTopColor: 'rgba(194,252,133,0.4)' }}
                    />

                    {/* Logo circle */}
                    <Box
                        sx={{
                            width: { xs: 90, md: 110 },
                            height: { xs: 90, md: 110 },
                            borderRadius: '50%',
                            backgroundColor: COLORS.accentLime,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 0 0 6px rgba(194,252,133,0.12)',
                            zIndex: 1,
                        }}
                    >
                        <Box
                            component="img"
                            src={logo}
                            alt="Grassroots Sports Logo"
                            sx={{ width: { xs: 56, md: 70 } }}
                        />
                    </Box>
                </Box>
            </motion.div>

            <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.15 }}
            >
                <Box
                    sx={{
                        display: 'inline-block',
                        backgroundColor: COLORS.accentLime,
                        color: COLORS.accentDarkGreen,
                        px: 2.5,
                        py: 0.5,
                        borderRadius: '6px',
                        mb: 4,
                        transform: 'skewX(-8deg)',
                    }}
                >
                    <Typography variant="subtitle1" fontWeight={700} sx={{ transform: 'skewX(8deg)', display: 'block', letterSpacing: 1 }}>
                        COMING SOON
                    </Typography>
                </Box>
            </motion.div>

            <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.25 }}
            >
                {/* <Typography
                    variant="h2"
                    fontWeight={800}
                    sx={{
                        color: COLORS.accentLime,
                        textTransform: 'uppercase',
                        letterSpacing: 2,
                        mb: 2,
                        fontSize: { xs: '2.2rem', sm: '3rem', md: '4rem' },
                    }}
                >
                    Our Framework
                </Typography> */}
            </motion.div>

            <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.35 }}
            >
                <Typography
                    variant="body1"
                    sx={{
                        color: 'rgba(255,255,255,0.75)',
                        maxWidth: 560,
                        mx: 'auto',
                        mb: 6,
                        fontSize: { xs: '1rem', md: '1.1rem' },
                        lineHeight: 1.8,
                    }}
                >
                    We're working hard to bring you something exceptional. Our page will be live very soon. Stay tuned!
                </Typography>
            </motion.div>

            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.45 }}
            >
                <AccentButton label="Back to Home" href="/" />
            </motion.div>
        </Box>
    );
};

export default ComingSoon;
